import { DashboardStats } from "../../../types/dashboard";

export const actionTypes = {
  GET_DASHBOARD_STATS: "dashboard/GET_DASHBOARD_STATS",
  GET_DASHBOARD_STATS_SUCCESS: "dashboard/GET_DASHBOARD_STATS_SUCCESS",
  GET_DASHBOARD_STATS_ERROR: "dashboard/GET_DASHBOARD_STATS_ERROR",
};

interface DashboardState {
  stats: DashboardStats | null;
  loading: boolean;
  error: string | null;
}

const initialState: DashboardState = {
  stats: null,
  loading: false,
  error: null,
};

export const dashboardReducer = (
  state = initialState,
  action: any
): DashboardState => {
  switch (action.type) {
    case actionTypes.GET_DASHBOARD_STATS:
      return { ...state, loading: true, error: null };
    case actionTypes.GET_DASHBOARD_STATS_SUCCESS:
      return { ...state, loading: false, stats: action.payload };
    case actionTypes.GET_DASHBOARD_STATS_ERROR:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
